import { render } from "./MailStatusModalComponent.vue?vue&type=template&id=48e85fd0"
import script from "./MailStatusModalComponent.vue?vue&type=script&lang=js"
export * from "./MailStatusModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__